/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { HTMLAttributes, ReactElement } from 'react'
import SelectionInput from './SelectionInput'
import { Table } from '@mantine/core'

export type SelectableRowProps = {
  value: number | string | string[];
}

function SelectableRow (
  props: SelectableRowProps & HTMLAttributes<HTMLTableRowElement>
): ReactElement {
  const {
    children,
    value,
    ...others
  } = props

  // todo set backgroundColor if selected

  return (
    <Table.Tr
      // aria-selected={includes(value)}
      // style={{ backgroundColor }}
      {...others}
    >
      <Table.Td>
        <SelectionInput value={value} />
      </Table.Td>
      {children}
    </Table.Tr>
  )
}

export default SelectableRow
